import { BP42InitialState } from '@r1-frontend/bp42/reducer/initialState';

const isNeedToShowSpecOffer = (state: BP42InitialState): boolean => state.needToShowSpecialOffer;

export default isNeedToShowSpecOffer;
